module.exports = __webpack_public_path__ + "img/bathtub-icon.e89d0a7d.svg";